import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import {CONFIGS} from "../../constants";

const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: CONFIGS.baseUrl,
        prepareHeaders: (headers) => {
            const token = sessionStorage.getItem("kctoken")
            if (token) headers.set("Authorization", `Bearer ${token}`)
            return headers
        }
    }),
    // Все теги всех инжектируемых слайсов обязаны быть перечислены здесь:
    // незарегистрированный тег RTK Query молча игнорирует, и его
    // providesTags/invalidatesTags превращаются в no-op (данные не
    // перезапрашиваются после мутаций).
    tagTypes: [
        "User",
        "Product",
        "OneProduct",
        "Orders",
        "OrderComments",
        "Inactive",
        "Requests",
        "Seniority",
        "Vouchers",
        "Experience",
        "ExperienceCategories",
        "ExperienceLevels",
        "ExperienceRequests",
        "Achievements",
        "AchievementCategories",
        "Mascots",
        "Coupons",
        "AppCopy",
        "Seasons",
        "SeasonResults",
    ],
    endpoints: () => ({})
})

export default api
